import AppTopbar from 'components/App/AppTopbar';
import React, { useEffect, useState } from 'react';
import BreadCrumbsCustom from 'components/BreadCrumbsCustom/BreadCrumbsCustom';
import { useSelector } from 'react-redux';
import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { selectAuth, selectUser } from 'app/slice/authSlice';
import { APP_ECONTRACT } from 'constants/global';

export default function TopbarWrap({ children }) {
    let location = useLocation();

    const [height, setHeight] = useState(56);
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    const userPer = useSelector(selectUser);
    const authData = useSelector(selectAuth);

    const LIST_BREADCRUMB_CONSTANT = [
        { label: <FormattedMessage id="manage-user-topbar" />, link: routerMain.USER },
        { label: <FormattedMessage id="manage-role-topbar" />, link: routerMain.ROLE },
        { label: <FormattedMessage id="system-setting-topbar" />, link: routerMain.CONFIG },
        {
            label: <FormattedMessage id="setting-cts-topbar" />,
            link: routerMain.CONFIG_DIGITAL_CERTIFICATE,
        },
        {
            label: <FormattedMessage id="submit-topbar" />,
            link: routerMain.CATEGORY_SUBMISSION,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.VIEW}`,
                },
                {
                    label: <FormattedMessage id="add" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="update" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.EDIT}`,
                },
                {
                    label: authData?.app !== APP_ECONTRACT
                    ? <FormattedMessage id="add-quick-signer" />
                    : <FormattedMessage id="add" />
                    ,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.QUICK_SIGNER_ADD}`,
                },
                {
                    label: authData?.app !== APP_ECONTRACT
                    ? <FormattedMessage id="update-quick-signer" />
                    : <FormattedMessage id="update" />
                    ,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.QUICK_SIGNER_EDIT}`,
                },
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_VIEW}`,
                },
                {
                    label: <FormattedMessage id="add-batch-signer" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_ADD}`,
                },
                {
                    label: <FormattedMessage id="update-batch-signer" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_EDIT}`,
                },
                {
                    label: <FormattedMessage id="CategorySubmission.request_stop_effect" />,
                    link: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.STOP_EFFECT}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="approve-topbar" />,
            link: routerMain.CATEGORY_SUBMISSION_CONFIRM,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CATEGORY_SUBMISSION_CONFIRM}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="completed-topbar" />,
            link: routerMain.CATEGORY_SUBMISSION_CONFIRMED,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CATEGORY_SUBMISSION_CONFIRMED}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="refused-topbar" />,
            link: routerMain.CATEGORY_SUBMISSION_REFUSE,

            children: [
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CATEGORY_SUBMISSION_REFUSE}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="incoming-topbar" />,
            link: routerMain.CATEGORY_DOCUMENT_INCOMING,
        },
        {
            label: <FormattedMessage id="outgoing-topbar" />,
            link: routerMain.CATEGORY_DOCUMENT_SENT,
        },
        {
            label: <FormattedMessage id="personal-doc-topbar" />,
            link: routerMain.PERSONAL_DOCUMENT,
        },
        {
            label: <FormattedMessage id="type-doc-topbar" />,
            link: routerMain.CATEGORY_DOCUMENT_TYPE,
        },
        {
            label: <FormattedMessage id="sample-doc" />,
            link: routerMain.CATEGORY_DOCUMENT,
            children: [
                {
                    label: <FormattedMessage id="add" />,
                    link: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="update" />,
                    link: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.EDIT}`,
                },
                {
                    label: <FormattedMessage id="set-position" />,
                    link: `${routerMain.CATEGORY_DOCUMENT}${routerPathMain.POSITION}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="type-processes" />,
            link: routerMain.CATEGORY_TYPE_PROCEDURE,
        },
        {
            label: <FormattedMessage id="processes-topbar" />,
            link: routerMain.CATEGORY_PROCEDURE,
            children: [
                {
                    label: <FormattedMessage id="add" />,
                    link: `${routerMain.CATEGORY_PROCEDURE}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="update" />,
                    link: `${routerMain.CATEGORY_PROCEDURE}${routerPathMain.EDIT}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="manage-organizationtree-topbar" />,
            link: routerMain.ORGANIZATION_TREE,
        },
        {
            label: <FormattedMessage id="sample-email-topbar" />,
            link: routerMain.EMAIL_TEMPLATE,
            children: [
                {
                    label: <FormattedMessage id="update" />,
                    link: `${routerMain.EMAIL_TEMPLATE}${routerPathMain.EDIT}`,
                },
                {
                    label: <FormattedMessage id="upgrade" />,
                    link: `${routerMain.EMAIL_TEMPLATE}${routerPathMain.UPGRADE}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="manage-position-topbar" />,
            link: routerMain.CATEGORY_POSITION,
        },

        {
            label: <FormattedMessage id="sample-sign-topbar" />,
            link: routerMain.SIGN_TEMPLATE,
        },
        {
            label: <FormattedMessage id="password-change" />,
            link: routerMain.CHANGE_PASS_WORD,
        },
        {
            label: <FormattedMessage id="account-manage" />,
            link: routerMain.PROFILE,
        },
        {
            label: <FormattedMessage id="list-organization" />,
            link: routerMain.CHANGE_ORGANIZATION,
        },
        {
            label: <FormattedMessage id="mail-history-topbar" />,
            link: routerMain.MAILING_HISTORY,
        },
        {
            label: <FormattedMessage id="user-manual-topbar" />,
            link: routerMain.USER_MANUAL,
        },
        {
            label: <FormattedMessage id="filestorage-setting-topbar" />,
            link: routerMain.CONFIG_STORAGE,
        },
        {
            label: <FormattedMessage id="partner-topbar" />,
            link: routerMain.PARTNER,
        },
        {
            label: <FormattedMessage id="contract-topbar" />,
            link: routerMain.CONTRACT,
            children: [
                {
                    label: <FormattedMessage id="add" />,
                    link: `${routerMain.CONTRACT}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="update" />,

                    link: `${routerMain.CONTRACT}${routerPathMain.EDIT}`,
                },
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CONTRACT}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="contract-approve-topbar" />,
            link: routerMain.CONTRACT_CONFIRM,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,

                    link: `${routerMain.CONTRACT_CONFIRM}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="Contract.contract-management-confirmed.title" />,
            link: routerMain.CONTRACT_CONFIRMED,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,

                    link: `${routerMain.CONTRACT_CONFIRMED}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="Contract.contract-management-refuse.title" />,
            link: routerMain.CONTRACT_REFUSE,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,

                    link: `${routerMain.CONTRACT_REFUSE}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="ContractDocument.top_bar.title" />,
            link: routerMain.CONTRACT_DOCUMENT,
            children: [
                {
                    label: <FormattedMessage id="add" />,
                    link: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="update" />,

                    link: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.EDIT}`,
                },
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="ContractDocumentConfirm.top_bar.title" />,
            link: routerMain.CONTRACT_DOCUMENT_CONFIRM,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CONTRACT_DOCUMENT_CONFIRM}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="template-contract-topbar" />,
            link: routerMain.CATEGORY_CONTRACT_TYPE,
            children: [
                {
                    label: <FormattedMessage id="add" />,

                    link: `${routerMain.CATEGORY_CONTRACT_TYPE}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="update" />,

                    link: `${routerMain.CATEGORY_CONTRACT_TYPE}${routerPathMain.EDIT}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="setup-wizard" />,
            link: routerMain.QUICK_WIZARD,
        },
        {
            label: <FormattedMessage id="PersonalDocument.sign-multi-doc" />,
            link: routerMain.SIGN_MULTIPLE,
        },
        {
            label: <FormattedMessage id="release_note" />,
            link: routerMain.RELEASE_NOTE,
        },
        {
            label: <FormattedMessage id="contract-complaints" />,
            link: routerMain.CONTRACT_COMPLAINTS,
            children: [
                {
                    label: <FormattedMessage id="add" />,
                    link: `${routerMain.CONTRACT_COMPLAINTS}${routerPathMain.ADD}`,
                },
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.CONTRACT_COMPLAINTS}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="synthesis_report" />,
            link: routerMain.SYNTHESIS_REPORT,
            children: [
                {
                    label: <FormattedMessage id="view-detail" />,
                    link: `${routerMain.SYNTHESIS_REPORT}${routerPathMain.VIEW}`,
                },
            ],
        },
        {
            label: <FormattedMessage id="AuthorityManager.list" />,
            link: routerMain.AUTHORITY_MANAGER,
        },
        {
            label: <FormattedMessage id="common.create_ticket_support" />,
            link: routerMain.CREATE_TICKET_SUPPORT,
        },
        {
            label: <FormattedMessage id="approve-group" />,
            link: routerMain.APPROVAL_GROUP,
        },
        {
            label: <FormattedMessage id="common.serviceManagement" />,
            link: routerMain.SERVICE_MANAGER,
        },
        {
            label: <FormattedMessage id="ReferenceTemplateText.title" />,
            link: routerMain.REFERENCE_TEMPLATE_TEXT,
        },
        {
            label: <FormattedMessage id="ReferenceTemplateContract.title" />,
            link: routerMain.REFERENCE_TEMPLATE_CONTRACT,
        },
    ];

    function findRoute(findbreadcrumbs, pathnameSplit, breadcrumbs, start) {
        let path = '';
        for (let i = 1; i <= start; i++) {
            path = path + `/${pathnameSplit[i]}`;
        }

        if (findbreadcrumbs.hasOwnProperty('children')) {
            const childbrc = findbreadcrumbs.children.find((child) => child.link === path);
            if (childbrc) {
                breadcrumbs.push(childbrc);
                findRoute(childbrc, pathnameSplit, breadcrumbs, start + 1);
            } else {
                return breadcrumbs;
            }
        }
        return breadcrumbs;
    }

    useEffect(() => {
        // const breadcrumb=model.find((brc=> brc.link===window.location.pathname));
        const pathnameSplit = location.pathname.split('/');

        const findbreadcrumb = LIST_BREADCRUMB_CONSTANT.find((brc) => brc.link === location.pathname);
        if (findbreadcrumb) {
            setBreadcrumbs([findbreadcrumb]);
        } else {
            if (pathnameSplit.length > 2) {
                const findbreadcrumb = [];
                const findbreadcrumbs = LIST_BREADCRUMB_CONSTANT.find((brc) => brc.link === `/${pathnameSplit[1]}`);
                findbreadcrumb.push(findbreadcrumbs);
                if (findbreadcrumbs) {
                    const breadcrumb = findRoute(findbreadcrumbs, pathnameSplit, findbreadcrumb, 2);
                    setBreadcrumbs(breadcrumb);
                } else {
                    setBreadcrumbs([]);
                }
            } else {
                setBreadcrumbs([]);
            }
        }

        // eslint-disable-next-line
    }, [location.pathname]);

    return (
        <React.Fragment>
            <AppTopbar setHeight={setHeight} />
            <div style={{ paddingTop: height }} className="layout-content">
                <div className="hr--4 p-px-5 p-d-flex p-align-center p-justify-between bg-surface-b">
                    <BreadCrumbsCustom model={LIST_BREADCRUMB_CONSTANT} breadcrumbs={breadcrumbs} />
                    <span className="text-fw-600">{userPer?.agency?.agency_name}</span>
                </div>
                {children}
            </div>
        </React.Fragment>
    );
}

